<!-- start section footer -->
<div id="contact" class="text-center bg-dark text-light pt-5 pb-2 rounded-top mt-5">
  <div class="container">

    <div class="row align-items-start">

      <!-- LEFT SIDE -->
      <div class="col-md-4 text-start mb-4">
        <h3 class="fw-bold text-white mb-3 lh-base">
          Find Best Deal and Pubs in your City
        </h3>

        <!-- LinkedIn -->
        <a href="https://www.linkedin.com/in/e-digital-lab-36b8953a9" target="_blank" class="d-inline-flex align-items-center justify-content-center 
                  border rounded-circle text-white mt-3 me-2 shadow-sm text-decoration-none"
          style="width: 40px; height: 40px;">
          <i class="fa-brands fa-linkedin fs-5"></i>
        </a>
      </div>

      <!-- CENTER (unchanged structure)-->
      <div class="col-md-4">
        <div class="socials-media text-center">
          <ul class="list-unstyled">
            @for (entry of availableLinks | keyvalue | slice:0:7; track entry) {
            <li></li>
            }
          </ul>
        </div>
      </div>

      <!-- RIGHT SIDE — Address -->
      <div class="col-md-4 text-start mb-4">
        <h4 class="fw-bold text-white mb-3 lh-base">Address</h4>

        <div class="d-flex flex-column gap-2 text-light fs-5">
          <div class="stretch-on-hover">
            <i class="fa-solid fa-building me-2"></i> 123 Baleshwar,
          </div>
          <div class="stretch-on-hover">
            <i class="fa-solid fa-location-dot me-2"></i> Odisha, India 756002
          </div>

          <div>
            <a href="mailto:edigitallab123@gmail.com" class="text-decoration-none text-light stretch-on-hover">
              <i class="fa-solid fa-envelope me-2"></i> edigitallab123@gmail.com
            </a>
          </div>

          <div>
            <a href="tel:+1234567890" class="text-decoration-none text-light stretch-on-hover">
              <i class="fa-solid fa-phone me-2"></i> +1234567890
            </a>
          </div>

        </div>
      </div>

    </div>
  </div>
  <hr class="mb-2 mt-0 border-secondary opacity-25" />
  <div class="container">
    <div class="credits small text-secondary">
      {{footerNote}}
      <a href="/" class="text-decoration-none text-light fw-semibold">{{hostname}}</a>
      All rights reserved. |
      <a routerLink="/terms" class="footer-terms-link text-secondary">Terms & Policy</a>
    </div>

  </div>
</div>